import { Calendar, ChevronDown, Loader2 } from 'lucide-react';
import styles from './date-range-picker.module.css';

interface DateRangePickerProps {
  selectedDays: number;
  onSelectDays: (days: number) => void;
  isLoading?: boolean;
}

const REFRESHING_METRICS = 'Refreshing metrics';
const DATE_OPTIONS = [
  { value: 0, label: 'All time' },
  { value: 30, label: '30 days' },
  { value: 60, label: '60 days' },
  { value: 90, label: '90 days' },
];

export const DateRangePicker = ({
  selectedDays,
  onSelectDays,
  isLoading = false,
}: DateRangePickerProps) => (
  <div className={styles.picker}>
    <span className={styles.calendar}>
      {isLoading ? <Loader2 className={styles.spinner} aria-hidden /> : <Calendar aria-hidden />}
    </span>
    <select
      aria-label="Date range"
      aria-busy={isLoading}
      value={selectedDays}
      onChange={event => onSelectDays(Number(event.target.value))}
      disabled={isLoading}>
      {DATE_OPTIONS.map(option => (
        <option key={option.value} value={option.value}>
          {option.label}
        </option>
      ))}
    </select>
    <ChevronDown className={styles.chevron} aria-hidden />
    <span className={styles.status} role="status">
      {isLoading ? REFRESHING_METRICS : ''}
    </span>
  </div>
);
